import { ScanProvider } from "types/generated";
import { ScanProviderConfigItem } from "views/Account/Scans/types";

type RegionOption = {
  id: string;
  location: string;
};

type ScanProviderGroup = {
  type: ScanProvider;
  version: string;
  integration: string;
  integrationName: string | null;
  regions: string[];
};

const getRegionLabel = (regionId: string, regionOptions: RegionOption[]): string => {
  const option = regionOptions.find((regionOption) => regionOption.id === regionId);
  return option ? `${option.location} (${option.id})` : regionId;
};

export const getRegionLabels = (regionIds: string[], regionOptions: RegionOption[]): string[] =>
  regionIds.map((regionId) => getRegionLabel(regionId, regionOptions));

export const groupProviderConfigs = (
  providerConfigs: Array<ScanProviderConfigItem>
): ScanProviderGroup[] => {
  const groups: ScanProviderGroup[] = [];

  for (const config of providerConfigs) {
    const existingGroup = groups.find(
      (group) =>
        group.type === config.type &&
        group.version === config.version &&
        group.integration === config.integration
    );

    if (existingGroup) {
      if (!existingGroup.regions.includes(config.config.region)) {
        existingGroup.regions.push(config.config.region);
      }
      continue;
    }

    groups.push({
      type: config.type,
      version: config.version,
      integration: config.integration,
      integrationName: config.integrationName,
      regions: [config.config.region],
    });
  }

  return groups;
};
